import { render, staticRenderFns } from "./PowerSelectBox.vue?vue&type=template&id=c8b26d1a"
import script from "./PowerSelectBox.vue?vue&type=script&lang=ts"
export * from "./PowerSelectBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports